import { z } from 'zod';
import { marketingOptOutSchema } from '../components/MarketingOptOut/validation';

export const schema = z.object({
  name: z.string().min(1, 'form.Required field'),
  email: z.string().min(1, 'form.Required field').email('form.Invalid email format'),
  category: z
    .object({ label: z.string(), value: z.enum(['purchase_query', 'other']) })
    .nullable()
    .transform((data, ctx) => {
      if (data === null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'form.Required field',
        });

        return z.NEVER;
      }

      return data.value;
    }),
  organization: z
    .object({ label: z.string(), value: z.string() })
    .optional()
    .nullable()
    .transform((data) => data?.value),
  country: z
    .object({
      label: z.string(),
      value: z.string(),
    })
    .optional()
    .nullable()
    .transform((data) => data?.value),
  loc: z
    .object(
      {
        label: z.string(),
        value: z.string(),
      },
      { required_error: 'form.Required field' }
    )
    .optional()
    .nullable()
    .transform((data) => data?.value),
  subject: z.string(),
  question: z.string().min(1, 'form.Required field'),
  login: z.string().optional(),
  _gotcha: z.string(),
  ...marketingOptOutSchema.shape,
});
